import {FILTERS_ARGS} from '../courseLeadersConst';

export default class CLFilterDTO {
  constructor(queries = {}) {
    this.search = queries[FILTERS_ARGS.SEARCH];
    this.isArchived = queries[FILTERS_ARGS.IS_ARCHIVED];
  }

}
